import { render, staticRenderFns } from "./EditPaymentTermPage.vue?vue&type=template&id=8b005596"
import script from "./EditPaymentTermPage.vue?vue&type=script&lang=js"
export * from "./EditPaymentTermPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports